import React, { Component } from 'react';
import FormatText from '../Utils/TextFormatter';
import Button from './Shared/Button';


export default class GiftEnd extends Component {

	render() {
        const {style, noGiftTitle, noGiftDescription, testHasGift} = this.props;
        
        let gotGift = global.SumbitResult ? global.SumbitResult.gotGift : false; 
        let giftURL, gotGiftTitle, gotGiftExplanation, giftButtonText;
        
        if(gotGift) {
            giftURL = global.SumbitResult.giftURL;
            gotGiftTitle = global.SumbitResult.giftTitle;
            gotGiftExplanation = global.SumbitResult.giftExplanation;
            giftButtonText = global.SumbitResult.ButtonText;
        }

        if(testHasGift){
            gotGift = true;
            giftURL = "https://buyme.co.il/";
            gotGiftTitle = "תודה על שיתוף הפעולה!";
            gotGiftExplanation = "מוזמנים להנות מקפה ומאפה באמצעות השובר המצורף ☕️ לשאלות ניתן לפנות לחברת נופשונית בטלפון 03-5234754 או במייל cs@nofshonit.co.il";
            giftButtonText = "לקבלת השובר";
            // gotGiftTitle = "תודה על שיתוף הפעולה!";
            // gotGiftExplanation = "מוזמנים להנות מכרטיס זוגי לסרט באמצעות השובר המצורף 🎬";
            // giftButtonText = "לקבלת השובר";
        }


		const padding = 40;
		

        return <div style={style}>
            <div style={{
                 position: "absolute",
				 bottom: 0,
				 height: 360,
                 right: padding,
                 left: padding,
                 textAlign: "right",
            }}>
                <h1>{gotGift ? gotGiftTitle : noGiftTitle}</h1>
                <div className="separation-bar"/>
                <div className= 'paragraph'>{FormatText(global.isMale, gotGift ? gotGiftExplanation : noGiftDescription)}</div>
                {(gotGift && giftURL !== 'noURL') && <div style={{
                    position:"absolute",
                    bottom:padding,
                    width:"100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}>
                    <br/>
                    <Button text={giftButtonText} isActive={true} onClick={()=>{
                        window.open(giftURL, '_blank');
                    } }/>
                </div>}
            </div>
	  	</div>
    }
    
}



// WEBPACK FOOTER //
// ./src/Comp/GiftEnd.js